import React, { useMemo } from "react"
import { CountryData, defaultCountries } from "react-international-phone"
import "react-international-phone/build/index.css"
import { StyledPhoneInput } from "./styles"
import isFeatureEnabled from "shared/featureflags/helperFunctions"

interface PhoneInputFieldProps {
    label?: string
    value: string
    onChange: (value: string) => void
    error?: string
    required?: boolean
    inputProps?: Record<string, unknown>
    defaultCountry: string
    dataCy?: string
}

const COUNTRIES = ["us", "ca"]

export const COUNTRIES_DATA = defaultCountries.filter((country) => COUNTRIES.includes(country[2]))

export const PhoneInputField: React.FC<PhoneInputFieldProps> = ({
    label = "Phone number",
    value,
    onChange,
    error,
    required = false,
    inputProps = {},
    defaultCountry,
    ...props
}) => {
    const countriesData = useMemo(() => {
        const isUSAndCanadaOnlyFFEnabled = isFeatureEnabled("ff_ngg_only_us_and_canada_phone_numbers")
        return isUSAndCanadaOnlyFFEnabled ? COUNTRIES_DATA : defaultCountries
    }, [])

    const valueWithoutDialCode = useMemo(() => {
        if (!value) return ""
        return value.split(" ").slice(1).join(" ")
    }, [value])

    const handleChange = (phone: string, countryCode: string) => {
        const currentCountry = defaultCountries.find((country) => country[2] === countryCode)
        if (!currentCountry) return

        const dialCodeNumber = currentCountry[3]
        const dialCode = `+${dialCodeNumber}`
        onChange(`${dialCode} ${phone}`)
    }

    return (
        <StyledPhoneInput
            defaultCountry={defaultCountry}
            value={valueWithoutDialCode}
            countries={countriesData}
            onChange={handleChange}
            disableDialCodeAndPrefix={true}
            showDisabledDialCodeAndPrefix={true}
            {...props}
            inputProps={{
                name: "phone",
                "aria-label": label,
                "aria-invalid": !!error,
                "aria-required": required,
                "data-cy": props.dataCy,
                required,
                ...inputProps,
            }}
        />
    )
}
